import { IconButton } from '@mui/material';
import Badge from '@mui/material/Badge';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import CloseIcon from 'atoms/Icons/CloseIcon';
import { observer } from 'mobx-react-lite';
import DirectNotifications from 'molecules/Notifications/DirectNotifications/DirectNotifications';
import WatchNotifications from 'molecules/Notifications/WatchNotifications/WatchNotifications';
import Tabs from 'molecules/Tabs';
import React, { useState } from 'react';
import { useStore } from 'stores/store';
import { useUserAuth } from 'utils/hooks/useUserAuth';

import s from './NotificationTabs.module.scss';

const NotificationTabs = ({ onClose }: { onClose?: () => void }) => {
  const { NotificationStore } = useStore();
  const { isManagement } = useUserAuth();

  const [unread, setUnread] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState(0);

  const onChangeUnread = () => {
    setUnread(!unread);
  };

  const withBadge = (label: string, show: boolean) => (
    <Badge variant="dot" invisible={!show} color="error" sx={{ '& .MuiBadge-badge': { mr: -1 } }}>
      {label}
    </Badge>
  );

  return (
    <div className={s.NotificationTabs}>
      <div className={s.NotificationTabs__header}>
        <Typography variant="h5">Notifications</Typography>
        <div className={s.NotificationTabs__unread}>
          <span>Show unread</span>
          <Switch
            className={s.NotificationTabs__switch}
            onChange={onChangeUnread}
            size="small"
            disabled={false}
            checked={unread}
          />
          {onClose && (
            <IconButton edge="end" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </div>
      <div className={s.NotificationTabs__content}>
        {isManagement && <DirectNotifications unread={unread} />}
        {!isManagement && (
          <>
            <Tabs
              divider
              value={activeTab}
              tabs={[
                {
                  label: withBadge('Direct', NotificationStore.unreadDirectCount > 0),
                  value: 0
                },
                {
                  label: withBadge('Watchlist', NotificationStore.unreadWatchCount > 0),
                  value: 1
                }
              ]}
              onChange={(e, value) => setActiveTab(value)}
            />
            {activeTab === 0 && <DirectNotifications unread={unread} />}
            {activeTab === 1 && <WatchNotifications unread={unread} />}
          </>
        )}
      </div>
    </div>
  );
};

export default observer(NotificationTabs);
